import { Directive } from '@angular/core';
import { AccountCenterSection } from '../utilities/accountCenterSection.component';
import { PolicyLink, PolicyModal } from '../../../interfaces/account-center/PolicyLink';
import { AccountCenterService } from '../../../services/account-center/account-center.service';
import { ModalService } from '../../../services/modal/modal.service';
import { ModalType } from '../../../../js/interfaces/CoverpathTypes';
import { AmorphicService } from '../../../services/amorphic/amorphic.service';
import { CoverpathBaseAccountCenterController } from '../../../../js/controllers/CoverpathBaseAccountCenterController';
import { CoverpathUtils } from '../../../../js/static/CoverpathUtils';

@Directive()
export abstract class BasePolicyLinksComponent extends AccountCenterSection {
  title: string = 'Policy Links';
  topLinks: Array<PolicyLink> = new Array<PolicyLink>();
  bottomLinks: Array<PolicyLink> = new Array<PolicyLink>();
  initialized: boolean = false;
  isLoading = false;

  accountCenterController: CoverpathBaseAccountCenterController;

  ngOnInit(): void {
    this.subscribeToAccountCenterService();
  }

  async processWorkflowAction(workflowAction: string): Promise<void> {
    await this.constructLinks(workflowAction);
  }

  protected constructor(
    accountCenterService: AccountCenterService,
    amorphicService: AmorphicService,
    protected modalService: ModalService
  ) {
    super(amorphicService, accountCenterService);
    this.accountCenterController = amorphicService.controller.accountCenterController;
  }

  protected ownerNameEmailEncode(): string {
    return (
      'Owner_UserName=' +
      encodeURIComponent(this.accountCenterService.primaryPolicy.owner.getFullNameOfOwner()) +
      '&Owner_Email=' +
      encodeURIComponent(this.accountCenterService.primaryPolicy.owner.email)
    );
  }

  async constructLinks(workflowAction: string): Promise<void> {
    const primaryPolicyData = this.accountCenterService.getPolicyDataFromPolicy(
      this.accountCenterService.primaryPolicy.__id__ as string
    );

    if (this.hasInForcePolicy || (this.hasCanceledPolicy && primaryPolicyData.getCACIsLifeInsurancePolicy())) {
      this.title = 'Policy Links';
      return this.constructLinksForPolicyMode(workflowAction);
    } else {
      this.title = 'Application Links';
      return this.constructLinksForApplicationMode(workflowAction);
    }
  }

  async constructLinksForApplicationMode(workflowAction: string): Promise<void> {
    const newTopLinks = new Array<PolicyLink>();
    const primaryPolicyData = this.accountCenterService.getPolicyDataFromPolicy(
      this.accountCenterService.primaryPolicy.__id__ as string
    );

    //applicationSignedDate is set when we get the signal back from DocuSign
    if (primaryPolicyData.getCACApplicationSignedDate()) {
      newTopLinks.push(new PolicyLink('View Application PDF', this.accountCenterController.getViewApplicationURL()));
    }

    if (this.canCancel) {
      if (CoverpathUtils.isInForce(workflowAction) && primaryPolicyData.getCACIsCoverpathPolicy()) {
        newTopLinks.push(new PolicyModal('Cancel Policy', 'cancelPolicy'));
      } else {
        newTopLinks.push(new PolicyModal('Cancel Policy', 'cancelPolicySimple'));
      }
    }

    this.topLinks = newTopLinks;
    return Promise.resolve();
  }

  abstract constructLinksForPolicyMode(workflowAction: string): Promise<void>;

  openModal(modalName: string): void {
    this.modalService.activate({
      type: ModalType[modalName],
    });
  }
}
